'use strict';

const fixBackgroundImagesFlickerIE = () => {
    // fixing scrolling problems in IE11 and Edge - fixed background flickers on scroll
    if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/1/)) {
        $('body').on('mousewheel', function () {
            event.preventDefault();
            const wd = -(event.deltaY);
            const csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }
};

module.exports = fixBackgroundImagesFlickerIE;
